var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('api-list',{attrs:{"type":"itemsShippingHistory","model":_vm.models.itemsShippingHistory,"quick-filters":_vm.quickFiltersSetup.itemsShippingHistory,"preFilters":[['items.item_id', 'eq', _vm.item.id]],"filter-on-mount":"","no-querystring":"","in-modal":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }